import React, { useEffect } from 'react';
import styled from "styled-components";
import { ReactComponent as HomeIcon } from "../../components/ui/styles/home.svg";
import { WrapperHead, WrapperHeadBtn } from "../edit";
import Breadcrumb, { BreadcrumbItem, BreadcrumbLink } from "../../components/ui/Breadcrumb";
import AddDomainModal from "./AddDomainModal";
import { useDispatch, useSelector } from "react-redux";
import { fetchPlatformDomains } from '../../redux/features/PlatformSettingSlice';
import UpdateDomainModal from './UpdateDomainModal';


export const Wrapper = styled.section`
    min-height: calc(100vh - 58px);
    margin-left: 250px;
    padding: 30px;
    box-sizing: border-box;
`;

export const ProjectBlock = styled.div`
    .smallTitle {
        font-size: 16px !important;
        color: #666 !important;
        padding: 0;
        text-align: left;
        margin: 0 0 25px;
        font-weight: 700 !important;
    }
`;
export const CardWrapper = styled.div`
    display: Grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 20px;
    .smallTitle {
        font-size: 16px !important;
        color: #666 !important;
        padding: 0;
        text-align: left;
        margin: 0 0 25px;
        font-weight: 700 !important;
    }
    & > div {
        min-height: 250px;
    }
`;


export const EditPlatformSettingsTableBody = styled.div`
    padding: 0;
    margin: 0;
    list-style-type: none;
    background: #fff;
    table {
        width: 100%;
        border-collapse: collapse;

        tr {
            border-bottom: 1px solid #ed8154;
        }
        
        tr:hover, tr:focus-within {
            background:rgb(252, 241, 237);
        }

        tbody tr:last-child {
            border-bottom: none;
        }

        td, th {
            border-right: 1px solid #ed8154;
            padding: 4px 15px;
            font-size: 14px;
            color: #999;
            line-height: 22px;
            text-align: left;
            svg,
            img {
            height: 22px;
            width: 22px;
        }
    }
`;

export const EditPlatformSettingsTable = styled.div`
    background: #fff;
    border-radius: 0;
    box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 12%);
    overflow: hidden;
    border: 1px solid #ed8154;
    max-height: calc(100vh - 195px);
    overflow: auto;
`;

export const ListActionBtn = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    button {
        height: 26px;
        width: 26px;
        background: #fff;
        border: 2px solid #fff;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer important;

        &:hover {
            background:rgb(253, 225, 215);
            border-color: #ed8154;
        }
        
        svg {
            pointer-events: none;
            path {
                fill: #ed8154;
            }
        }
        
        &:last-child svg path {
            fill: #982727;
        }
    }
`;

const DomainSettings = () => {
    const dispatch = useDispatch();
    const domains = useSelector(state => state.PlatformSetting.domains)
    useEffect(() => {
        dispatch(fetchPlatformDomains());
    }, []);

    return (
        <React.Fragment>
            <Wrapper>
                <WrapperHead>
                    <Breadcrumb primary>
                        <BreadcrumbLink to={"/home"}><BreadcrumbItem children={<HomeIcon />} /></BreadcrumbLink>
                        <BreadcrumbLink to={"/company-settings/overview"}><BreadcrumbItem children={"Setting"} /></BreadcrumbLink>
                        <BreadcrumbLink to={"/company-settings/edit"}><BreadcrumbItem children={"Platform Settings"} /></BreadcrumbLink>
                        <BreadcrumbLink to={"#"}><BreadcrumbItem children={"Domain Settings"} /></BreadcrumbLink>
                    </Breadcrumb>
                    <WrapperHeadBtn>

                        <AddDomainModal />

                    </WrapperHeadBtn>
                </WrapperHead>
                <ProjectBlock>
                    <h4 className="smallTitle">Domain Settings</h4>
                </ProjectBlock>
                <EditPlatformSettingsTable>
                    <EditPlatformSettingsTableBody>
                        {!domains.length ?
                            <div style={{ padding: 20 }}>No domains have been configured yet.</div> :
                            <table>
                                <thead>
                                    <tr>
                                        <th>Domain</th>
                                        <th>Active</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {domains.map((d) => {
                                        return (
                                            <tr key={d._id}>
                                                <td>{d.domain}</td>
                                                <td>{d.active ? 'Active' : 'Inactive'}</td>
                                                <td><UpdateDomainModal domain={d} /></td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        }

                    </EditPlatformSettingsTableBody>
                </EditPlatformSettingsTable>


            </Wrapper>
        </React.Fragment>
    )
}

export default DomainSettings;